import { http } from '@/core/api/';
import locationApi from '@/modules/common/location.api';
import schoolTypes from '@/utils/constants/student/schoolTypes';

const apiUrl = 'api/tapRequests';

export const getTapRequestSchoolGrade = () => {
  return http.get(`${apiUrl}/schoolgrades`);
};

export const getTapRequestFocusType = () => {
  return http.get(`${apiUrl}/focustypes`);
};

export const gettaprequestSearchInitialFilterValues = () => {
  return http.get(`${apiUrl}/initfilters`);
};

export const gettaprequestSearchData = (properties) => {
  return http.get(`${apiUrl}/history`, { params: { ...properties } });
};

export const getTapRequestHistoryDetails = (requestId) => {
  return http.get(`${apiUrl}/historydetails`, { params: { requestId } });
};

export const getStudentTapRequest = (studentSIE) => {
  return http.get(`${apiUrl}/gettaprequestbystudent/${studentSIE}`);
};

export const getStudentTapRequestById = (studentSIE, tapRequestId) => {
  return http.get(
    `${apiUrl}/getstudenttaprequestbyid/${studentSIE}/${tapRequestId}`
  );
};

export const getTapRequest = (tapRequestId) => {
  return http.get(`${apiUrl}/${tapRequestId}`);
};

export const getFacilitatorAnalysis = (tapRequestId) => {
  return http.get(`${apiUrl}/${tapRequestId}/facilitatinganalysis`);
};

export const getCSEEAnalysis = (tapRequestId) => {
  try {
    return http.get(`${apiUrl}/${tapRequestId}/director`);
  } catch {
    return null;
  }
};

export const getCentralLevel = (tapRequestId) => {
  try {
    return http.get(`${apiUrl}/${tapRequestId}/centrallevel`);
  } catch {
    return null;
  }
};

export const getAmendmentHistory = (tapRequestId) =>
  http.get(`${apiUrl}/${tapRequestId}/amendmenthistory`);

export const getSAEEAnalysis = (tapRequestId) => {
  try {
    return http.get(`${apiUrl}/${tapRequestId}/saeeanalysis`);
  } catch {
    return null;
  }
};

export const getDocumentTypesByCode = (parameter) => {
  try {
    return http.get(`api/documents/documenttypes?codetype=${parameter}`);
  } catch {
    return [];
  }
};

export const getFacilitatorAnalysisbystudent = (parameter) => {
  return http.get(`${apiUrl}/facilitatinganalysisbystudent/${parameter}`);
};

export const getCurrentAcademicYear = () => {
  return http.get('/api/academicyears/current');
};

export const getMunicipalities = () => {
  return http.get('/api/schools/municipalities');
};

export const getAcademicYears = (yearType) => {
  return http.get(
    `api/academicyears/academicyearfromintotype?minYear=2021&yearType=${yearType ??
      'CURRENT'}`
  );
};

export const getPositions = (group) => {
  let parameter = group ? `?group=${group}` : '';
  return http.get(`/api/signature/availablepositions${parameter}`);
};

export const getPurposes = (parameter) => {
  return http.get(`api/questionnaire/questions?questionnaireType=${parameter}`);
};

export const hasTapRequest = (studentSieId, academicYearId) => {
  return http.get(`api/tapRequests/${academicYearId}/exist/${studentSieId}`);
};

export const deleteCOMPURecommendation = (id, questionSection) => {
  return http.delete(
    `api/tapRequests/${id}/compurecommendations/${questionSection}`
  );
};

export const deleteSchoolRecommendation = (id) => {
  return http.delete(
    `api/tapRequests/${id}/facilitatinganalysis/schoolrecommendations`
  );
};

export const deleteCSEEConsult = (id) => {
  return http.delete(`api/tapRequests/${id}/facilitatinganalysis/cseeconsult`);
};

export const deleteDocument = (parameter) => {
  return http.delete(`${apiUrl}/document/${parameter}`);
};

export const replaceDocument = (tapRequestId, documentTypeId, file) => {
  const formData = new FormData();
  formData.append('File', file);

  return http.post(
    `${apiUrl}/${tapRequestId}/replacedocument?documentTypeId=${documentTypeId}`,
    formData
  );
};

export const deleteDirector = (tapRequestId) => {
  return http.delete(`${apiUrl}/${tapRequestId}/director`);
};

export const getStudentTransferFilters = (filters) => {
  return http.post(`${apiUrl}/studenttransfer/filters`, filters);
};
export const schoolRecommendationCatalogApi = {
  async getRegions({ academicYearId }) {
    return await locationApi.getRegions({
      academicYearId,
      schoolTypes: schoolTypes.Institutions,
    });
  },

  async getDistricts({ academicYearId, regionId }) {
    return await locationApi.getDistricts({
      academicYearId,
      regionId,
      schoolTypes: schoolTypes.Institutions,
    });
  },

  async getMunicipalities({ academicYearId, regionId }) {
    return await locationApi.getMunicipalities({
      academicYearId,
      regionId,
      schoolTypes: schoolTypes.Institutions,
    });
  },

  async getSchools({ academicYearId, regionId, districtId }) {
    return await locationApi.getSchools({
      academicYearId,
      regionId,
      districtId,
      schoolTypes: schoolTypes.Institutions,
    });
  },
};
export const getCentralLevelAlternativeLocationCategories = async () => {
  const { data } = await http.get(
    `${apiUrl}/centrallevel/alternativelocationcategories`
  );
  return data || [];
};
export const getCentralLevelNumberOfStudents = async () => {
  const { data } = await http.get(`${apiUrl}/centrallevel/numberofstudents`);
  return data || [];
};
export const getCentralLevelServices = async () => {
  const { data } = await http.get(`${apiUrl}/centrallevel/services`);
  return data || [];
};
export const getCentralLevelSchoolGrades = async () => {
  const url = 'api/books/grades';
  const { data } = await http.get(url);

  return data || [];
};

export const getTransferManagementLocations = (
  academicYearId,
  companyId,
  municipalityId
) => {
  return http.get(
    `${apiUrl}/transfermanagementlocation/${academicYearId}/${companyId}/${municipalityId}`
  );
};

export const getTransferManagementSpecialists = (
  academicYearId,
  companyId,
  municipalityId,
  locationId,
  isTeacher,
  isServiceAssistant
) => {
  return http.get(
    `${apiUrl}/transfermanagementspecialists/${academicYearId}/${companyId}/${municipalityId}/${locationId}/${isTeacher}/${isServiceAssistant}`
  );
};

export const getTransferHistory = (id) => {
  return http.get(`${apiUrl}/transferhistory/${id}`);
};

export const getTransferManagement = (id) => {
  return http.get(`${apiUrl}/transfermanagement/${id}`);
};

export const saveAdmissionManagement = (params) => {
  return http.post(`${apiUrl}/savetransfermanagement`, params);
};

export const getTabRequestValidity = (params) =>
  http.get(`${apiUrl}/validity`, { params });

export const getTabRequestApproveLetterHistory = (params) =>
  http.get(`${apiUrl}/approvedletterhistory`, { params });

export const saveValidity = (params) =>
  http.post(`${apiUrl}/saveValidity`, params);

export const getValidityGeneralInformation = (requestId, academicYearId) =>
  http.get(
    `${apiUrl}/validity/generalinformation/${requestId}/${academicYearId}`
  );

export const getValidityServices = (params) =>
  http.get(`${apiUrl}/validity/services`, { params });

export const getTapRequestHistory = async (params) => {
  const res = await http.get(`${apiUrl}/requestshistory/`, {
    params: {
      studentSieId: params.studentSieId,
      academicYearId: params.academicYearId,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize,
    },
  });

  return res;
};

export const getTherapyservicesfilters = async () => {
  const { data } = await http.get(`api/tapRequests/therapyservicesfilters`);

  return data;
};

export const getServiceTotalCost = (params) =>
  http.get(`${apiUrl}/serviceTotalCost`, { params });

export const getServiceCost = async (params) =>
  http.get(`${apiUrl}/companycontract/servicecost`, { params });

export const hasValidContractByLocationSchoolId = (locationSchoolId) =>
  http.get(
    `${apiUrl}/companycontract/hasvalidcontract?locationSchoolId=${locationSchoolId}`
  );

export const isSchoolContractDirectPayment = (tapRequestId) =>
  http.get(
    `${apiUrl}/companycontract/isSchoolContractDirectPayment?tapRequestId=${tapRequestId}`
  );

export const changeStatus = (requestId, payload) =>
  http.put(`${apiUrl}/${requestId}/changestatus`, payload);

export const getServiceToShowBillFlag = (
  academicYearId,
  companyId,
  serviceDate
) =>
  http.get(`${apiUrl}/${academicYearId}/${companyId}/is-bill-due`, {
    params: { serviceDate },
  });
